<div class="network-diagram" #networkDiagramContainer id="{{diagramId}}"></div>
